module.exports = __webpack_public_path__ + "img/ai_help01_img_04.c38d2ced.png";